import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import ThemeSwitcher from "../Components/ThemeSwitcher";
import FullscreenToggle from "../Components/FullScreenToggle";

export default function AppLayout() {
  return <AppLayoutContent />;
}

function AppLayoutContent() {
  return (
    <Box
      sx={{
        position: "relative",
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: "background.default",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          display: "flex",
          justifyContent: "flex-end",
          p: 1,
        }}
      >
        <FullscreenToggle />
        <ThemeSwitcher />
      </Box>
      <Outlet />
    </Box>
  );
}
